import { render, staticRenderFns } from "./ProductCarouselImage.vue?vue&type=template&id=69d9f8f5&scoped=true&lang=pug"
import script from "./ProductCarouselImage.vue?vue&type=script&lang=js"
export * from "./ProductCarouselImage.vue?vue&type=script&lang=js"
import style0 from "./ProductCarouselImage.vue?vue&type=style&index=0&id=69d9f8f5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d9f8f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d9f8f5')) {
      api.createRecord('69d9f8f5', component.options)
    } else {
      api.reload('69d9f8f5', component.options)
    }
    module.hot.accept("./ProductCarouselImage.vue?vue&type=template&id=69d9f8f5&scoped=true&lang=pug", function () {
      api.rerender('69d9f8f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductCarouselImage.vue"
export default component.exports